import styled from 'styled-components';
import { IconMoreAndroid } from '@spotify-internal/creator-tape';
import { color, spacer } from '@spotify-internal/tokens';

export const IconMore = styled(IconMoreAndroid).attrs({
  color: color.white,
  size: 24,
})`
  margin-right: ${spacer.spacer4};
`;
